import { siteConfig } from './config';

export const navItems = [
  { label: 'Weight Loss', href: '#weight-loss' },
  { label: 'Sexual Health', href: '#ed' },
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Why VT.co', href: '#why-vt' },
  { label: 'FAQ', href: '#faq' },
] as const;

export const accountLinks = {
  assessment: siteConfig.assessmentUrl,
} as const;
